import React from 'react';
import {useUserContext} from "../context/UserContext";

function HomePage(props) {
    const {user: {info: user}} = useUserContext();
    return (
        <div>
            <h1>Welcome <b>{user.sessionName}</b></h1>
            <p>Select an option from the side menu</p>
        </div>
    );
}

export default HomePage;